import * as React from "react";
import type { SVGProps } from "react";
const SvgTicket01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.4 15.14v-.194m0-2.809v-.194m0-2.796v-.194M5.012 3.46H12a2.625 2.625 0 0 0 5.248 0h1.74a3.81 3.81 0 0 1 3.81 3.812v9.457a3.81 3.81 0 0 1-3.81 3.811h-1.74a2.625 2.625 0 0 0-5.248 0h-6.99A3.81 3.81 0 0 1 1.2 16.73V7.272A3.81 3.81 0 0 1 5.012 3.46"
    />
  </svg>
);
export default SvgTicket01;
